/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
export var BaseControlTheme = /*@__PURE__*/ (function (BaseControlTheme) {
    BaseControlTheme[BaseControlTheme["Default"] = 0] = "Default";
    BaseControlTheme[BaseControlTheme["DenaliLight"] = 1] = "DenaliLight";
    BaseControlTheme[BaseControlTheme["MaterialLight"] = 2] = "MaterialLight";
    return BaseControlTheme;
})({});
/**
 * @hidden
 */
export var BaseControlTheme_$type = /*@__PURE__*/ markEnum('BaseControlTheme', 'Default,0|DenaliLight,1|MaterialLight,2');
//# sourceMappingURL=BaseControlTheme.js.map
